<template>
  <section class="content">
    <!-- <HomeGrid3Promocao v-if="$vssWidth < 761" /> -->
    <SliderPrincipal />
    <HomeGrid3 />
  </section>
</template>

<script>
import HomeGridIndex from '@/components/HomeGridIndex.vue'
import HomeGrid3 from '@/components/HomeGrid3.vue'
import SliderPrincipal from '@/components/SliderPrincipal.vue'
import { mapActions } from 'vuex'
import VueScreenSize from 'vue-screen-size'

export default {
  name: 'Home',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    HomeGridIndex,
    HomeGrid3,
    SliderPrincipal
  },
  created () {
    this.limparFinalizacaoPedido()
    document.title = 'Promoções - Ilha do Caranguejo'
  },
  methods: {
    ...mapActions('menu', ['finalizacaoPedido', 'toggleMenu']),
    limparFinalizacaoPedido () {
      this.finalizacaoPedido(false)
      this.toggleMenu(false)
    }
  }
}
</script>

<style scoped>
.content {
  max-width: 1174px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 354px;
  grid-template-areas:
    "SliderPrincipal SliderPrincipal SliderPrincipal"
    "box_3grid box_3grid box_3grid"
}

@media (max-width: 760px) {
  .content {
    margin: 0;
    grid-template-columns: 100%;
    grid-template-areas:
      "box_3grid"
  }
}



// WEBPACK FOOTER //
// src/views/Home.vue